import { render, staticRenderFns } from "./AuthorizationRuleHeader.vue?vue&type=template&id=537ffd1c&scoped=true&"
import script from "./AuthorizationRuleHeader.vue?vue&type=script&lang=js&"
export * from "./AuthorizationRuleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ffd1c",
  null
  
)

export default component.exports